import { reactive } from "vue";
import { type Product } from "@src/api";
import { type Good } from "./useOrders";

export type OrderItem = {
  seriaId: string;
  seria: Product;
  goods: Good[];
  isCollected: boolean;
  isCanceled: boolean;
};

const state = reactive<{ list: OrderItem[] }>({ list: [] });

export const useOrderItemListState = () => {
  const setList = (list: OrderItem[]) => {
    state.list = list;
  };
  return {
    value: state,
    set: setList,
  };
};
